'use strict';

require("core-js/modules/es6.object.define-property");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Columns = undefined;

var _reactCssThemr = require('react-css-themr');

var _identifiers = require('../../../identifiers');

var _Columns = require('./Columns');

var _style = require('./../style.helper');

var _style2 = _interopRequireDefault(_style);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    'default': obj
  };
}

var ThemedColumns = (0, _reactCssThemr.themr)(_identifiers.GRID_COLUMNS, _style2['default'])(_Columns.Columns);
exports['default'] = ThemedColumns;
exports.Columns = ThemedColumns;